<template>
  <span>
    <v-select v-if="!readonly"
      class="d-inline-block select-field-no-child-input mx-2" required dense hide-details
      append-icon="" text="text" value="value" height="14px" style="min-width: 120px;"
      v-model="name"
      :items="counties"
      @change="onQueryChange"/>
    <span v-else>{{ name }} </span>
  </span>
</template>

<script>
export default {
  name: "LivesIn",
  props: {
    onQueryChange: {
      type: Function,
      required: true,
    },
    initialConfig: {
      type: Object,
      required: true,
    },
    readonly: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      name: "",
    };
  },
  computed: {
    counties() {
      return [...Object.keys(this.$store.state.acornCodes.acornCodes ?? {})].sort()
    }
  },
  created() {
    this.onChangeInitialConfig();
  },
  methods: {
    onChangeInitialConfig() {
      if (this.initialConfig.name) {
        this.name = this.initialConfig.name;
      }
    },
    getQuery() {
      return {
        name: this.name,
      };
    },
  },
  watch: {
    initialConfig: {
      handler() {
        this.onChangeInitialConfig();
      },
      immediate: true,
    },
  },
};
</script>

<style scoped></style>
